module.exports = "./img/1bafa925e557dcea3a4472e9c6a97f21.png";